// extracted by mini-css-extract-plugin
var _1 = "Loader_absolute__ca282";
var _2 = "Loader_fixed__6f400";
var _3 = "Loader_gradient__c9a2a";
var _4 = "Loader_gradientSpinner__61aa3";
var _5 = "Loader_inline__61be8";
var _6 = "Loader_resources__493a3";
var _7 = "Loader_root__71cac";
var _8 = "Loader_rotate__32180";
var _9 = "Loader_spinner__d24ec";
export { _1 as "absolute", _2 as "fixed", _3 as "gradient", _4 as "gradientSpinner", _5 as "inline", _6 as "resources", _7 as "root", _8 as "rotate", _9 as "spinner" }
